import * as core from '../../../../../../../core'
import * as rp from '../rp'

export const RESOURCE = {
  payload: {
    alias: 'trends',
    appAlias: rp.RESOURCE.payload.alias,
    description: 'View your performance over time',
    display: {
      isMain: true,
      position: 1,
    },
    name: 'Trends',
    page: { alias: 'rp:trends' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
